/* istanbul ignore file */
export default {
  effectiveDate: {
    type: 'string',
    required: true,
  },
  kpiParameters: {
    type: 'array',
    maxSize: 50,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        name: {
          type: 'string',
          required: true,
        },
        type: {
          type: 'string',
          required: true,
        },
      },
    },
  },
};
